import actions from '../constants/action-types';

const validateValue = () => ({
  type: actions.VALIDATE_VALUE,
});

export default validateValue;
